<template>
  <PubPage showProject @changeProject="changeProject">
    <template slot="pageHeader">
      <div class="home-tabs">
        Hello，{{ userInfo.realName }}，祝你工作愉快！
      </div>
    </template>

    <div class="home-top">
      <a-row :gutter="20" type="flex">
        <a-col flex="1">
          <a-row :gutter="20">
            <a-col :span="12">
              <section class="pub-card">
                <PubPageTitle title="学校人数" />
                <div class="home-top-nav">
                  <div class="home-t-title">
                    <div class="home-t-title-item">
                      <span><em class="d1"></em>学校人数（人）</span>
                      <i>{{ info.onJobQty || 0 }}</i>
                    </div>
                    <div class="home-t-title-item1">
                      <span>待同步（{{ info.waitQty || 0 }}人）</span>
                      <span>已同步（{{ info.syncQty || 0 }}人）</span>
                    </div>
                  </div>
                  <div class="home-t-progress">
                    <a-progress
                      :percent="100"
                      :success-percent="(info.onJobQty / info.totalQty) * 100"
                      status="active"
                      :showInfo="false"
                      :strokeWidth="20"
                    />
                  </div>
                  <div class="home-t-info">
                    <!-- <p>
                      <span>学校总人数（{{ info.totalQty || 0 }}人）</span>
                    </p> -->
                    <!-- <p>
                      <i class="d2"></i>
                      <span>已离职人数（{{ info.quitQty || 0 }}人）</span>
                    </p> -->
                  </div>
                </div>
              </section>
            </a-col>
            <a-col :span="12">
              <section class="pub-card">
                <PubPageTitle title="学校当日考勤" />
                <div class="home-top-day">
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <div class="home-top-day-item t1">
                        <div class="home-t-d-icon">
                          <a-icon type="dashboard" />
                        </div>
                        <div class="home-t-d-text">
                          <span>{{ info.currentWorkQty || 0 }}</span>
                          <i>当日考勤人数（人）</i>
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="12">
                      <div class="home-top-day-item t2">
                        <div class="home-t-d-icon"><a-icon type="frown" /></div>
                        <div class="home-t-d-text">
                          <span>{{ info.currentNoWorkQty || 0 }}</span>
                          <i>当日考勤异常人数（人）</i>
                        </div>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </section>
            </a-col>
          </a-row>
        </a-col>
        <a-col flex="200px">
          <section class="pub-card">
            <PubPageTitle title="学生人脸采集" />
            <div class="home-top-wx">
              <img src="~@/assets/images/wx.jpg" width="140" height="140" />
            </div>
          </section>
        </a-col>
      </a-row>
    </div>
    <section class="pub-card mt20">
      <PubPageTitle title="2023年整体出勤率" />
      <div class="home-top-echarts">
        <img src="~@/assets/images/img.jpg" />
      </div>
    </section>
  </PubPage>
</template>

<script>
import { Home } from "@/api";
import { mapState } from "vuex";
const columns = [
  {
    title: "姓名",
    dataIndex: "workerName",
    align: "center",
    fixed: "left",
    width: 100,
  },
  {
    title: "承包单位",
    dataIndex: "subContractName",
    align: "center",
    width: 200,
    fixed: "left",
  },
  {
    title: "班组名称",
    dataIndex: "teanName",
    hideInSearch: true,
    width: 120,
    fixed: "left",
    align: "center",
  },
  {
    title: "01/周四",
    dataIndex: "a",
    hideInSearch: true,
    scopedSlots: true,
    width: 80,
    align: "center",
  },
  {
    title: "02/周五",
    dataIndex: "b",
    hideInSearch: true,
    scopedSlots: true,
    width: 80,
    align: "center",
  },
  {
    title: "03/周六",
    dataIndex: "c",
    hideInSearch: true,
    scopedSlots: true,
    width: 80,
    align: "center",
  },
  {
    title: "04/周日",
    dataIndex: "d",
    hideInSearch: true,
    scopedSlots: true,
    align: "center",
    width: 80,
  },
  {
    title: "05/周一",
    dataIndex: "e",
    hideInSearch: true,
    scopedSlots: true,
    width: 80,
    align: "center",
  },
  {
    title: "06/周二",
    dataIndex: "f",
    hideInSearch: true,
    scopedSlots: true,
    width: 80,
    align: "center",
  },
  {
    title: "07/周三",
    dataIndex: "g",
    hideInSearch: true,
    scopedSlots: true,
    width: 80,
    align: "center",
  },
  {
    title: "08/周四",
    dataIndex: "g",
    hideInSearch: true,
    scopedSlots: true,
    width: 80,
    align: "center",
  },
  {
    title: "09/周五",
    dataIndex: "g",
    hideInSearch: true,
    scopedSlots: true,
    width: 80,
    align: "center",
  },
  {
    title: "10/周六",
    dataIndex: "g",
    hideInSearch: true,
    scopedSlots: true,
    width: 80,
    align: "center",
  },
  {
    title: "日期",
    dataIndex: "time",
    valueType: "range",
    hideInTable: true,
    align: "center",
  },
];
export default {
  components: {},
  computed: {
    ...mapState("user", ["userInfo"]),
  },
  data() {
    return {
      info: {
        loginId: "",
        name: "",
        password: "",
        secpassword: "",
        roleIds: ["6"],
      },
      form: {
        projectId: "",
      },
      loading: false,
      columns,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 切换学校
    changeProject() {
      // this.getDetail();
    },
    getDetail() {
      this.loading = true;
      Home.findTotalPersonnel(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.info = JSON.parse(JSON.stringify(res.data));
        }
        this.loading = false;
      });
    },

    getSlot(slots, slot = "default", data) {
      if (!slots || !Reflect.has(slots, slot)) {
        return null;
      }
      if (!this.isFunction(slots[slot])) {
        console.error(`${slot} is not a function!`);
        return null;
      }
      const slotFn = slots[slot];
      if (!slotFn) return null;
      return slotFn(data);
    },

    changePage(data) {
      this.form.page = data.current;
      this.form.limit = data.size;
      this.getList();
    },
    //搜索回调
    searchBack(data) {
      data.current = 1;
      data.size = this.form.size;
      this.form = data;
      this.getList();
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          console.log(valid);
          // let newForm = JSON.parse(JSON.stringify(this.form));
          // newForm.password = md5(newForm.password).toUpperCase();
          // delete newForm.secpassword;
          // if (this.type == "add") {
          //   this.addsave(newForm);
          // } else if (this.type == "edit") {
          //   delete newForm.password;
          //   this.updatesave(newForm);
          // }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less">
@import "./style.less";
</style>
